import { v4 as uuidv4 } from "uuid";
import thumb1 from "../../assets/img/Services/NPD/factory-manager-reading-instructions-computer-while-checking-measurements-steel-bolt-industrial-building-manual-workers-are-background.webp";
import thumb2 from "../../assets/img/Services/PI/photo-automobile-production-line-welding-car-body-modern-car-assembly-plant-auto-industry-male-worker-orange-protective-helmet.webp";
import thumb3 from "../../assets/img/Services/QA/finance-businessman-success-person-workplace-accounting.webp";
import thumb4 from "../../assets/img/Services/TPQI/tpqi.jpg";
import thumb5 from "../../assets/img/Services/PDI/carpenter-works-with-tree.webp";
import thumb6 from "../../assets/img/Services/TPQI/mms.avif";
import thumb7 from "../../assets/img/Services/VD/handshake.webp";
import thumb8 from "../../assets/img/Services/CRVE/architectural-blueprints.webp";


const blogThreeData = [
  {
    id: 1,
    thumbnail: "/assets/images/factory.webp",
    img: "/assets/images/factory.webp",
    meta: "Development",
    author: "Vedant Tech",
    title: "New Product Development",
    link: "/news-details",
    category: "Service",
    slug: "new-product-development",
    description: "Vedant Technology supports customers in new product development from drawing stage to production. We help in feasibility study, process selection, tooling development, sampling, and production planning.",
    subServices: [
      "Feasibility Study",
      "Process Selection",
      "Tooling Development",
      "Prototype Development",
      "Sample Submission",
      "Process Planning",
      "Vendor Development",
      "Mass Production Support"
    ]
  },
  {
    id: 2,
    thumbnail: "/assets/images/photo.webp",
    meta: "Implementation",
    author: "Vedant Tech",
    title: "Process Implementation",
    link: "/news-details",
    category: "Service",
    slug: "process-implementation",
    description: "We support industries in setting up and implementing manufacturing processes for new and existing products. We help in process planning, machine selection, tooling, process flow, and production setup.",
    subServices: [
      "Process Flow Preparation",
      "Machine Selection",
      "Tooling & Fixture Planning",
      "Cycle Time Study",
      "Layout Planning",
      "Production Line Setup",
      "Process Optimization",
      "Productivity Improvement"
    ]
  },
  {
    id: 3,
    thumbnail: "/assets/images/finance.webp",
    meta: "Audits",
    author: "Vedant Tech",
    title: "Quality Audits",
    link: "/news-details",
    category: "Service",
    slug: "quality-audits",
    description: "We provide quality audit services to improve manufacturing systems and product quality. We conduct process audits, system audits, and supplier audits.",
    subServices: [
      "Process Audit",
      "System Audit",
      "Supplier Audit",
      "Product Audit",
      "Quality Improvement Support",
      "Rejection Analysis",
      "Process Capability Study",
      "SPC Implementation Support"
    ]
  },
  {
    id: 4,
    thumbnail: "/assets/images/tpqi.jpg",
    meta: "Inspection",
    author: "Vedant Tech",
    title: "Third Party Quality Inspection",
    link: "/news-details",
    category: "Service",
    slug: "third-party-quality-inspection",
    description: "Vedant Technology provides third party inspection services for customers who want independent inspection support.",
    subServices: [
      "Incoming Material Inspection",
      "In-Process Inspection",
      "Final Inspection",
      "Pre-Dispatch Inspection",
      "Layout Inspection",
      "Visual Inspection",
      "Dimensional Inspection",
      "Packing Inspection"
    ]
  },
  {
    id: 5,
    thumbnail: "/assets/images/carpenter-works-with-tree.webp",
    meta: "Packaging",
    author: "Vedant Tech",
    title: "Packaging Development & Ideas",
    link: "/news-details",
    category: "Service",
    slug: "packaging-development-ideas",
    description: "We help customers develop cost-effective and safe packaging solutions for domestic and export shipments.",
    subServices: [
      "Export Packaging",
      "Domestic Packaging",
      "Returnable Packaging",
      "Corrugated Box Design",
      "Wooden Box / Pallet Packaging",
      "Damage Prevention Packaging",
      "Packaging Cost Reduction"
    ]
  },
  {
    id: 6,
    thumbnail: "/assets/images/mms.avif",
    meta: "Maintenance",
    author: "Vedant Tech",
    title: "Machine Maintenance Support",
    link: "/news-details",
    category: "Service",
    slug: "machine-maintenance-support",
    description: "We provide machine maintenance and production support services.",
    subServices: [
      "Machine Installation Support",
      "Machine Maintenance Planning",
      "Preventive Maintenance",
      "Breakdown Support",
      "Production Line Setup",
      "Process Setup Support",
      "Machine Shifting & Installation"
    ]
  },
  {
    id: 7,
    thumbnail: "/assets/images/handshake.webp",
    meta: "Vendor Dev",
    author: "Vedant Tech",
    title: "Vendor Development",
    link: "/news-details",
    category: "Service",
    slug: "vendor-development",
    description: "Vedant Technology helps customers develop reliable manufacturing vendors for different processes.",
    subServices: [
      "Forging",
      "Machining",
      "Fasteners",
      "Sheet Metal",
      "Extrusion",
      "Surface Treatment",
      "Heat Treatment",
      "Fabrication",
      "Laser Cutting",
      "Plastic & Rubber Moulding"
    ]
  },
  {
    id: 8,
    thumbnail: "/assets/images/architectural-blueprints.webp",
    meta: "Cost Reduction",
    author: "Vedant Tech",
    title: "Cost Reduction & Value Engineering (VAVE)",
    link: "/news-details",
    category: "Service",
    slug: "cost-reduction-value-engineering-vave",
    description: "We support customers in reducing product cost through design improvement, process change, alternate material, and alternate manufacturing methods.",
    subServices: [
      "Process Change",
      "Design Modification",
      "Alternate Material",
      "Alternate Vendor Development",
      "Cycle Time Reduction",
      "Process Optimization",
      "Packaging Cost Reduction",
      "Logistics Cost Reduction"
    ]
  }
];

export default blogThreeData;
